

export default {
  props: {
    diagramId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    images: []
  }),
  fetchOnServer: false,
  async fetch () {
    let { results: images } = await this.$serverBackend.get(`/diagrams/${this.diagramId}/before_after`)
    if (images.length === 0) {
      const { results: [freeSample] } = await this.$serverBackend.get('/diagrams', { name: 'free_sample' })
      const response = await this.$serverBackend.get(`/diagrams/${freeSample.id}/before_after`);
      ({ results: images } = response)
    }
    this.images = images
  },
  mounted () {
    const targetNode = document.getElementById('usage-example')
    const config = {
      attributes: true,
      childList: true,
      subtree: true
    }
    const callback = function () {
      window.dispatchEvent(new Event('resize'))
    }
    const observer = new MutationObserver(callback)
    observer.observe(targetNode, config)
  }
}
